import React from "react";
import css from "./CoachMark.module.scss";
import { coachmark_pin, pointer } from "../../Images/Icons";
import { NavLink } from "react-router-dom";
const CoachMarkStep7 = (props) => {
    return (
        <div style={{ position: "relative" }}>
            <div className={css.backdrop}>
                <div className={css.higlight7}>
                    <div className={css.point}>
                        <img src={coachmark_pin}/>
                    </div>
                    
                    <div className={css.content}>                    
                        <i class="fi fi-rr-cross-small"></i>
                        <div className={css.title}>🌱 Explore the positive impact of your energy choices!</div>
                        <div className={css.desc}>This section highlights environmental benefits like standard coal saved, CO2 reduced, and equivalent trees planted. Click here to see how your actions are making a difference for our planet. </div>
                        <div className={css.step}>7/10</div>
                        <NavLink to="/home">
                            <button className={css.prev} onClick={props.prev}>Previous</button>
                        </NavLink>
                        <NavLink to="/home/statistic">
                        <button className={css.next} onClick={props.next}>Next</button>
                        </NavLink>
                        
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CoachMarkStep7;
